export default "__VITE_ASSET__DbwZivtM__"